import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IanTranslateService } from 'core/services/ian-core-singleton.service';
import { _log } from '@shared/aux_helper_environment';
import { DinamicTagsComponent } from '../dinamic-tags.component';

@Component({
  selector: 'dinamic-tags-advanced-filter',
  templateUrl: './dinamic-tags-advanced-filter.component.html',
  styleUrls: ['./dinamic-tags-advanced-filter.component.scss'],
})
export class DinamicTagsAdvancedFilterComponent extends DinamicTagsComponent {
  constructor(public dialog: MatDialog, public router: Router, public fBuilder: UntypedFormBuilder, public translate: IanTranslateService) {
    super(dialog, router, fBuilder, translate);
  }

  // modelado con PayloadToSendTags
  _mapAuxFormToPayloadTags(form: UntypedFormGroup): any {
    const _tags = form.value;
    const payloadTags = [];
    const self = this;
    Object.keys(_tags).map(function (index) {
      let optionsSelected = _tags[index];
      if (false) _log(optionsSelected);
      // si es single option lo envio igual como un listado de una opcion
      if (optionsSelected) optionsSelected = self.multipleSelection ? optionsSelected : [optionsSelected];
      const indexSplited = index.split('_');
      const _index = indexSplited[0];
      // si el item no fue seleccionado, traer todos los resultados del mismo, para ello enviamos []
      const _tagValues = optionsSelected ? optionsSelected : [];
      payloadTags.push({ tagId: Number(_index), tagValues: _tagValues });
    });
    if (true) _log('[_mapAuxFormToPayloadTags]', { _tags, payloadTags });
    return payloadTags;
  }
}
